class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  updateCartObject() {
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        console.log("cart response");
        window.Cart = response;
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // if (document.documentElement.scrollTop) {
    //   var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop
    //   scrollTop = `-${scrollTop}px`
    //   document.documentElement.classList.add('noscroll')
    //   document.documentElement.style.top = scrollTop
    // }

    // const b = document.querySelector('html');
    // b.style.setProperty('--st', -(document.documentElement.scrollTop) + "px");
    // b.classList.add('noscroll');

    document.body.classList.add("noscroll");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);

    // document.documentElement.classList.remove('noscroll');
    // var scrollTop = document.documentElement.style.top
    // scrollTop = scrollTop.replace('-','').replace('px', '')
    // document.documentElement.scrollTop = scrollTop
    document.body.classList.remove("noscroll");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove("is-empty");
    this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      console.log("section");
      console.log(section);
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartItemComponents extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector(".bundle-toggle");
    this.bundleItems = this.querySelector(".bundle-items");
    this.size = this.dataset.size;

    if (this.toggleButton && this.bundleItems) {
      this.toggleButton.addEventListener("click", () => this.toggleItems());
    }
  }

  toggleItems() {
    const isExpanded =
      this.toggleButton.getAttribute("aria-expanded") === "true";
    const itemCount = this.bundleItems.children.length;

    this.toggleButton.setAttribute("aria-expanded", !isExpanded);
    this.bundleItems.hidden = isExpanded;

    // Update button text
    this.toggleButton.innerHTML = `
      ${isExpanded ? "Show" : "Hide"} ${this.size} items 
      <div style="width: 8px;">
        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
        </svg>
      </div>

      `;
  }
}

customElements.define("cart-item-components", CartItemComponents);

class BundleDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector(".bundle-dropdown-toggle");
    this.bundleList = this.querySelector(".cart-item-bundle-list");

    if (this.toggleButton && this.bundleList) {
      this.toggleButton.addEventListener("click", () => this.toggleDropdown());
    }
  }

  toggleDropdown() {
    const isExpanded =
      this.toggleButton.getAttribute("aria-expanded") === "true";
    const itemCount = this.bundleList.querySelectorAll("li").length;

    if (isExpanded) {
      this.toggleButton.setAttribute("aria-expanded", "false");
      this.bundleList.hidden = true;
      this.toggleButton.innerHTML = `Show bundle items<svg class="icon-caret" width="8" height="8" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    } else {
      this.toggleButton.setAttribute("aria-expanded", "true");
      this.bundleList.hidden = false;
      this.toggleButton.innerHTML = `Hide bundle items<svg class="icon-caret" width="8" height="8" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    }
  }
}

customElements.define("bundle-dropdown", BundleDropdown);

// Cart Discount Form Handler
class CartDiscountHandler {
  constructor() {
    this.initializeForm();
  }

  initializeForm() {
    // Use event delegation since cart drawer content can be dynamically loaded
    document.addEventListener('submit', (event) => {
      if (event.target.id === 'cart-discount-form') {
        event.preventDefault();
        this.handleSubmit(event);
      }
    });
  }

  getFormElements() {
    return {
      form: document.querySelector('#cart-discount-form'),
      input: document.querySelector('#discount-code-input'),
      successMessage: document.querySelector('#discount-code-success'),
      errorMessage: document.querySelector('#discount-code-error'),
      submitButton: document.querySelector('#cart-discount-form .discount-form__button')
    };
  }

  hideMessages() {
    const { successMessage, errorMessage } = this.getFormElements();
    if (successMessage) successMessage.style.display = 'none';
    if (errorMessage) errorMessage.style.display = 'none';
  }

  showError(message) {
    console.log('Showing error:', message);
    this.hideMessages();
    const { errorMessage } = this.getFormElements();
    if (errorMessage) {
      errorMessage.textContent = message;
      errorMessage.style.display = 'block';
    }
  }

  showSuccess(message) {
    console.log('Showing success:', message);
    this.hideMessages();
    const { successMessage } = this.getFormElements();
    if (successMessage) {
      successMessage.textContent = message;
      successMessage.style.display = 'block';
    }
  }

  setLoading(loading) {
    const { submitButton, input } = this.getFormElements();
    if (submitButton) {
      submitButton.disabled = loading;
      submitButton.textContent = loading ? 'Applying...' : 'Apply';
    }
    if (input) {
      input.disabled = loading;
    }
  }

  hideDiscountForm() {
    const discountFormContainer = document.querySelector('.cart-drawer__discount-form');
    if (discountFormContainer) {
      console.log('Hiding discount form container');
      discountFormContainer.style.display = 'none';
    }
  }

  hideDiscountFormIfNeeded() {
    // Check if there's a discount applied by looking for the discount display
    const discountDisplay = document.querySelector('.cart-drawer__discount-code');
    const discountFormContainer = document.querySelector('.cart-drawer__discount-form');
    
    if (discountDisplay && discountFormContainer) {
      console.log('Discount found in cart, hiding form');
      discountFormContainer.style.display = 'none';
    } else if (this.discountApplied && discountFormContainer) {
      console.log('Discount was applied by us, hiding form');
      discountFormContainer.style.display = 'none';
    }
  }

  showDiscountDisplayIfNeeded() {
    // If we applied a discount but the server-side display isn't showing yet, create it
    const existingDiscountDisplay = document.querySelector('.cart-drawer__discount-code');
    
    if (this.discountApplied && this.appliedDiscountCode && !existingDiscountDisplay) {
      console.log('Creating client-side discount display for:', this.appliedDiscountCode);
      this.createDiscountDisplay(this.appliedDiscountCode);
    }
  }

  createDiscountDisplay(code) {
    // Find where to insert the discount display (before the drawer__footer)
    const drawerFooter = document.querySelector('.drawer__footer');
    
    if (drawerFooter) {
      // Create the discount display element
      const discountDisplay = document.createElement('div');
      discountDisplay.className = 'cart-drawer__discount-code';
      discountDisplay.style.cssText = `
        padding: 12px 16px;
        background: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
        border-radius: 4px;
        margin-bottom: 16px;
        font-size: 14px;
        text-align: center;
      `;
      
      // Set the discount text (defaulting to 10% like the server-side logic)
      discountDisplay.textContent = `20% Off Applied for Code ${code}`;
      
      // Insert before the drawer footer
      drawerFooter.parentNode.insertBefore(discountDisplay, drawerFooter);
      
      console.log('Client-side discount display created');
    }
  }

  async applyDiscount(code) {
    console.log('Applying discount code:', code);
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    
    console.log('Discount application response:', response.status, response.statusText);
    
    if (!response.ok) {
      throw new Error(`Discount application failed: ${response.status} ${response.statusText}`);
    }
    
    return response;
  }

  async fetchCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) {
      throw new Error(`Cart fetch failed: ${response.status} ${response.statusText}`);
    }
    const cart = await response.json();
    console.log('Cart data:', cart);
    return cart;
  }

  checkForDiscount(cart, code) {
    console.log('Checking for discount:', code);
    console.log('Cart discount applications:', cart.discount_applications);
    
    // Check discount_applications array (this is the correct property name)
    if (cart.discount_applications && cart.discount_applications.length > 0) {
      const hasDiscount = cart.discount_applications.some(app => {
        console.log('Checking discount app:', app.title, 'vs', code);
        return app.title === code;
      });
      if (hasDiscount) return true;
    }

    // Also check line item discounts
    if (cart.items && cart.items.length > 0) {
      const hasItemDiscount = cart.items.some(item => 
        item.discounts && item.discounts.some(discount => discount.title === code)
      );
      if (hasItemDiscount) return true;
    }

    return false;
  }

  async handleSubmit(event) {
    console.log('Form submitted');
    const { input } = this.getFormElements();
    
    this.hideMessages();

    const code = input?.value.trim();
    if (!code) {
      this.showError('Please enter a discount code');
      return;
    }

    console.log('Processing discount code:', code);
    this.setLoading(true);

    try {
      await this.applyDiscount(code);
      
      // Wait a moment for the discount to be processed
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Check if the discount was actually applied
      const cart = await this.fetchCart();
      
      if (this.checkForDiscount(cart, code)) {
        this.showSuccess('Discount applied! Updating cart...');
        
        // Mark that we successfully applied a discount and store the code
        this.discountApplied = true;
        this.appliedDiscountCode = code;
        
        // Hide the form immediately since we know discount was applied
        this.hideDiscountForm();
        
        // Refresh the cart drawer sections instead of full page reload
        setTimeout(() => {
          this.refreshCartDrawer();
        }, 300);
      } else {
        this.showError('Invalid discount code. Please try again.');
      }
    } catch (error) {
      console.error('Discount application error:', error);
      this.showError('Unable to apply discount. Please try again.');
    } finally {
      this.setLoading(false);
    }
  }

  async refreshCartDrawer() {
    console.log('Refreshing cart drawer...');
    
    // Hide success/error messages immediately before refresh
    this.hideMessages();
    
    try {
      // Use the same method as CartItems.onCartUpdate() for cart-drawer-items
      const response = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      console.log('Fetched cart drawer section successfully');
      
      // Replace cart drawer items and footer like CartItems does
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          console.log(`Replacing ${selector}`);
          targetElement.replaceWith(sourceElement);
        }
      }
      
      // Also update the cart icon bubble
      const cartIconResponse = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-icon-bubble`);
      const cartIconText = await cartIconResponse.text();
      const cartIconHtml = new DOMParser().parseFromString(cartIconText, 'text/html');
      const cartIconTarget = document.querySelector('#cart-icon-bubble');
      const cartIconSource = cartIconHtml.querySelector('#cart-icon-bubble');
      
      if (cartIconTarget && cartIconSource) {
        console.log('Updating cart icon bubble');
        cartIconTarget.replaceWith(cartIconSource);
      }
      
      console.log('Cart drawer refreshed successfully');
      
      // Manually hide the discount form if it's still visible after refresh
      // This handles cases where the server-side template hasn't updated yet
      this.hideDiscountFormIfNeeded();
      
      // Show discount display if server-side hasn't updated yet
      this.showDiscountDisplayIfNeeded();
      
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      console.log('Falling back to page reload');
      window.location.reload();
    }
  }
}

// Initialize the discount handler
document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing cart discount handler');
  new CartDiscountHandler();
});

// Also initialize when cart drawer is opened (in case it's loaded dynamically)
document.addEventListener('click', function(event) {
  if (event.target.closest('#cart-icon-bubble')) {
    setTimeout(() => {
      const form = document.querySelector('#cart-discount-form');
      if (form && !window.cartDiscountHandler) {
        console.log('Initializing cart discount handler for dynamic content');
        window.cartDiscountHandler = new CartDiscountHandler();
      }
      
      // Check if we should hide the form and show discount display on cart drawer open
      if (window.cartDiscountHandler) {
        window.cartDiscountHandler.hideDiscountFormIfNeeded();
        window.cartDiscountHandler.showDiscountDisplayIfNeeded();
      }
    }, 100);
  }
});
